//region :: Imports ::
import MComponent from '../Component';
import {ReactElement} from 'react';

//endregion

/** */
type Props = {
    size?: 1 | 2 | 3 | 4 | 5;
}

/** */
class MSpacer extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        return (
            <span className={this.props.size !== undefined ? `mr-${this.props.size}` : 'mr-2'}/>
        );

    }

}

export default MSpacer;
